import { inject, isDevMode } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './services/auth.service';
import config from '../../../config';

export const authGuard: CanMatchFn = () => {
  // Lets `ng serve` render the UI locally when no Cognito user pool is configured.
  if (isDevMode() && !config.AWS_COGNITO_USER_POOL_ID) {
    return true;
  }

  const router = inject(Router);
  return inject(AuthService)
    .getUserBySession()
    .pipe(map((session) => (session ? true : router.createUrlTree(['/auth/login']))));
};
